import { render, staticRenderFns } from "./assunto.vue?vue&type=template&id=07816c0c"
import script from "./assunto.vue?vue&type=script&lang=js"
export * from "./assunto.vue?vue&type=script&lang=js"
import style0 from "./assunto.vue?vue&type=style&index=0&id=07816c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports